<template>
  <q-btn
    flat
    :color="iconColor"
    icon="help"
    size="sm"
    dense
    @click="layout = true"
  >
    <q-tooltip>View Pressure Documentation</q-tooltip>
  </q-btn>

  <q-dialog v-model="layout">
    <q-card
      :dark="isDarkModeGlobal"
      style="width: 800px; max-width: 80vw;"
    >
      <q-card-section>
        <div class="text-h6">
          Definitions
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none q-pa-none">
        <ppp-pnp-graph />
        <div class="bold-text q-pa-md">
          Pressure Amplitude<span class="normal-text">, also known as</span> Peak Positive Pressure (PPP)<span class="normal-text">, is used for estimating intensity.</span>

          Peak Rarefaction<span class="normal-text">, also known as </span>Peak Negative Pressure (PNP)<span class="normal-text">, is used for estimating the mechanical index. For symmetrical waves, PPP and PNP are equal. Please see the <a href="https://doi.org/10.1016/j.brs.2024.04.013" target="_blank"><strong>ITRUSST Standardised Reporting Consensus</strong></a> paper for information about situations in which PPP and PNP may differ.</span>
        </div>
        <div class="q-pa-md">
          Currently, this calculator cannot account for all the effects of unequal PPP and PNP, and therefore the option to use unequal PPP and PNP is unavailable. Please see the <a href="https://doi.org/10.1016/j.brs.2024.04.013" target="_blank"><strong>ITRUSST Standardised Reporting Consensus</strong></a> for further explanations and caveats.
        </div>
        <div class="q-pa-md">
          Note that in the TUS Calculator, the pressure amplitude is treated as independent of the acoustic power, which differs from real-world behavior. The calculator uses the pressure amplitude to calculate metrics such as the Isppa, while the acoustic power is specifically used to calculate the TIC in the skull.
        </div>
      </q-card-section>
      <q-card-actions
        align="right"
        class="text-primary"
      >
        <q-btn
          flat
          label="OK"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import PppPnpGraph from "./CanvasPeakPressureGraph.vue"
const layout = ref(false)
import {storeToRefs} from "pinia"
import { useCalculatorStore } from '../stores/calculator.store'
const calculatorStore = useCalculatorStore()
const {
  isDarkModeGlobal
} = storeToRefs(calculatorStore)

defineProps({
  iconColor: {
    type: String,
    default: 'primary'
  }
})
</script>
<style>

.bold-text {
  font-weight: bold;
}

.normal-text {
  font-weight: normal;
}
</style>